export const INTEGER_SIZE = 2000000000;

export const VENDORS_TRANSMISSION_TYPES = [
	{ displayValue: 'edi', id: 2 },
	{ displayValue: 'email', id: 1 },
];